import useChatRestClient from '@/Api/ChatRestClient';
import {useMutation} from '@tanstack/react-query';

export default function useGetStudentDetails(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (data: any) => void,
) {
  const ChatRestClient = useChatRestClient();
  type GetStudentDetailsResponse = {
    success: boolean;
    [key: string]: any;
  };

  const mutation = useMutation<GetStudentDetailsResponse>(
    async () => {
      const response = await ChatRestClient.get(
        'subscription/v1/get-student-details',
      );
      return response.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess && data?.success) {
          handleOnSuccess(data);
        } else if (handleOnError) {
          handleOnError(data);
        }
      },
    },
  );

  return {
    ...mutation,
  };
}
